// src/redux/commonSlice.js

import { createSlice } from '@reduxjs/toolkit'
import { deleteCookie, setCookie } from 'cookies-next'
import { IRedux, ISavedBranch } from '../types'

const initialState: IRedux['common'] = {
  future_order_time: '',
  filter_by_tags: [],
  filter_by: '',
  isMapModal: false,
  isMapModalLg: false,
  branches: {},
  orderIds: null,
  deliveryZones: {},
  searchedProduct: '',
  editingPoint: null,
  creatingPoint: false,
  points: [],
}

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    futureTime: (state, action) => {
      state.future_order_time = action.payload
    },
    setFilterTags: (state, action) => {
      state.filter_by_tags = action.payload
      setCookie('filtered_by_tags', action.payload, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
    },
    setFilter: (state, action) => {
      state.filter_by = action.payload
    },

    setDeliveryZone: (
      state,
      action: {
        payload: {
          shipper_id: string
          zone: { id: string; min_order_amount: number } | null
        }
      }
    ) => {
      const { shipper_id, zone } = action.payload
      if (!state.deliveryZones) state.deliveryZones = {}
      state.deliveryZones[shipper_id] = zone
    },
    findProduct: (state, action) => {
      state.searchedProduct = action.payload
    },
    clearSearch: (state) => {
      state.searchedProduct = ''
    },
    saveBranchData: (state, action: { payload: ISavedBranch }) => {
      if (action.payload.shipper_id) {
        state.branches[action.payload.shipper_id] = action.payload
      }
      setCookie('branch_id', action.payload?.id, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
      setCookie('branch_slug', action.payload?.slug, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
      // setCookie('menu_id', action.payload?.menu_id, {
      //   maxAge: 30 * 24 * 60 * 60,
      //   path: '/',
      // })
    },
    clearBranchData: (state, action: { payload: string | undefined }) => {
      if (action.payload) {
        state.branches[action.payload] = null
      } else {
        state.branches = {}
      }
      deleteCookie('branch_id')
      deleteCookie('branch_slug')
      // deleteCookie('menu_id')
    },
    onOpenMap: (state) => {
      state.isMapModal = true
    },
    onCloseMap: (state) => {
      state.isMapModal = false
      state.isMapModalLg = false
      state.editingPoint = null
      state.creatingPoint = false
    },
    setOrderIds: (state, action) => {
      state.orderIds = action.payload
    },
    setMapModalLg: (state, action) => {
      state.isMapModalLg = action.payload
    },
    clearOrderIds: (state) => {
      state.orderIds = null
    },
    createPoint: (state) => {
      state.isMapModal = true
      state.creatingPoint = true
    },
    openPoint: (state, action) => {
      state.isMapModal = true
      state.editingPoint = action.payload
    },
    savePoint: (state, action) => {
      state.points = state.points
        .filter((item) => item.address !== action.payload?.address)
        .map((item) => ({ ...item, isActive: false }))
      state.points.push(action.payload)
      state.editingPoint = null
    },
    updatePoint: (state, action) => {
      state.points = state.points.map((item) =>
        item.id === state.editingPoint?.id
          ? action.payload
          : { ...item, isActive: false }
      )
      state.editingPoint = null
    },
    activatePoint: (state, action) => {
      const selectedPoint = state.points.find(
        (item) => item.id === action.payload
      )
      if (selectedPoint?.location) {
        state.points = state.points.map((item) =>
          item.id !== selectedPoint.id
            ? { ...item, isActive: false }
            : { ...item, isActive: true }
        )
      }
    },
    removePoint: (state, action) => {
      const pointToRemove = state.points.find(
        (item) => item.id === action.payload
      )

      if (pointToRemove?.isActive) {
        state.branches = {}
        deleteCookie('branch_id')
        deleteCookie('branch_slug')
        // deleteCookie('menu_id')
      }

      state.points = state.points.filter((item) => item.id !== action.payload)
    },
  },
})

export default commonSlice.reducer
export const {
  createPoint,
  openPoint,
  setFilterTags,
  setFilter,
  setOrderIds,
  saveBranchData,
  clearOrderIds,
  savePoint,
  setMapModalLg,
  updatePoint,
  removePoint,
  activatePoint,
  onOpenMap,
  onCloseMap,
  findProduct,
  clearSearch,
  clearBranchData,
  setDeliveryZone,
} = commonSlice.actions
export const commonActions = commonSlice.actions
